import { ContentCardsModel } from "~/models/ContentCards";
import { ContentCardModel } from "~/models/ContentCard";

export const useContentRecommend = async () => {
  const contentCards = new ContentCardsModel();

  try {
    const resContents =
      await useFetchGet<ResponseCardContent>("/content/recommend");

    for (const item of resContents.items) {
      contentCards.addContent(
        new ContentCardModel(item.id, item.banner_image, item.title_th),
      );
    }

    return contentCards;
  } catch (_) {
    return contentCards;
  }
};
